'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _slide = require('react-burger-menu/lib/menus/slide');

var _slide2 = _interopRequireDefault(_slide);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _HeaderMenu = require('./HeaderMenu.css');

var _HeaderMenu2 = _interopRequireDefault(_HeaderMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderMenu = (_dec = (0, _reactCssModules2.default)(_HeaderMenu2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HeaderMenu, _Component);

  function HeaderMenu(props) {
    (0, _classCallCheck3.default)(this, HeaderMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderMenu.__proto__ || (0, _getPrototypeOf2.default)(HeaderMenu)).call(this, props));

    _this.clickMenu = function () {
      _this.setState({ menuOpen: !_this.state.menuOpen });
    };

    var titleWords = _config2.default.app.title.split(' ');
    var firstTwoTitleWords = titleWords.slice(0, 2).join(' ');
    _this.state = {
      menuOpen: false,
      firstTwoTitleWords: firstTwoTitleWords,
      lastTitleWord: titleWords[2]
    };
    return _this;
  }
  //


  (0, _createClass3.default)(HeaderMenu, [{
    key: 'render',

    //
    value: function render() {
      var styles = {
        bmBurgerButton: {
          position: 'relative',
          // width: '1.25rem',
          // height: '1.1rem',
          // float: 'right',
          float: 'left',
          cursor: 'pointer'
        },
        bmBurgerBars: {
          background: '#333',
          cursor: 'pointer'
        },
        bmIcon: {
          whiteSpace: 'nowrap',
          fontSize: '1.5em',
          fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        bmMenuWrap: {
          top: 0,
          zIndex: 10001,
          width: '80%',
          maxWidth: '80%',
          left: '0px'
        },
        bmCrossButton: {
          height: '1.6rem',
          width: '1.6rem',
          cursor: 'pointer'
        },
        bmCross: {
          background: '#333',
          cursor: 'pointer'
        },
        bmMenu: {
          background: 'white',
          padding: '0 2.5rem 0 0',
          fontSize: '1.15rem',
          top: 0,
          borderLeft: '1px solid #A3A3A3'
        },
        bmMorphShape: {
          fill: 'white'
        },
        bmItemList: {
          color: '#333',
          padding: '0 1rem 1rem 1rem',
          boxSizing: 'border-box'
        },
        bmOverlay: {
          background: 'rgba(0, 0, 0, 0.76)',
          top: 0,
          right: 0,
          zIndex: 10000
        }
      };
      //
      var link2 = _config2.default.app.title === 'Invest Your Values' ? [_config2.default.links.fff, 'Fossil Free Funds'] : [_config2.default.links.iyv, 'Invest Your Values'];
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'header-container-wrap' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'header-row' },
            _react2.default.createElement(
              'div',
              { styleName: 'c' },
              _react2.default.createElement(
                'div',
                { styleName: 'block-link first-block-link h5' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.ays,
                    title: 'As You Sow'
                  },
                  'As You Sow'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'block-link h5' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: link2[0],
                    title: link2[1]
                  },
                  link2[1]
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'c' },
              _react2.default.createElement(
                'div',
                { styleName: 'block-link h5' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.signup,
                    title: 'Sign up for email updates'
                  },
                  'Sign up'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'block-link donate h5' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.donate,
                    title: 'Donate to As You Sow'
                  },
                  'Donate'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'header-row' },
            _react2.default.createElement(
              'div',
              { styleName: 'c' },
              _react2.default.createElement(
                'div',
                { styleName: 'menu-wrap' },
                _react2.default.createElement(
                  _slide2.default,
                  {
                    styles: styles,
                    isOpen: this.state.menuOpen,
                    burgerButtonClassName: '',
                    customBurgerIcon: _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-bars' })
                      )
                    )
                  },
                  _react2.default.createElement(
                    'nav',
                    null,
                    _react2.default.createElement(
                      _reactFlexboxGrid.Row,
                      null,
                      _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 12, md: 1, lg: 2 }),
                      _components.MenuConfig.map(function (col, colI) {
                        return _react2.default.createElement(
                          _reactFlexboxGrid.Col,
                          { xs: 12, sm: 12, md: 3, lg: 3,
                            key: 'menu-col-' + colI,
                            styleName: 'menu-column'
                          },
                          col.map(function (item, itemI) {
                            return _react2.default.createElement(
                              'div',
                              {
                                key: 'menu-item-' + itemI,
                                styleName: 'menu-link-' + item[2]
                              },
                              _react2.default.createElement(
                                _components.Link,
                                {
                                  to: item[0],
                                  title: item[1]
                                },
                                item[3] ? _react2.default.createElement(
                                  'span',
                                  null,
                                  _react2.default.createElement(_components.LinkIcon, {
                                    nospace: true,
                                    faclass: 'fa-' + item[3]
                                  }),
                                  '\xA0'
                                ) : null,
                                item[1],
                                item[4] ? _react2.default.createElement(
                                  'span',
                                  { styleName: 'menu-subtitle' },
                                  item[4]
                                ) : null
                              )
                            );
                          })
                        );
                      })
                    )
                  ),
                  _react2.default.createElement(_components.IyvBanner, { hideTagline: true, hideLink: true })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'header-title' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: '/',
                    title: _config2.default.app.title
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'header-title-nowrap' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'header-strong' },
                      this.state.firstTwoTitleWords
                    ),
                    '\xA0',
                    _react2.default.createElement(
                      'span',
                      { styleName: 'header-mid' },
                      this.state.lastTitleWord
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'c' },
              _react2.default.createElement(
                'div',
                { styleName: 'block-link last-block-link h4' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    title: 'Search funds'
                  },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-search' }),
                  '\xA0Search'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return HeaderMenu;
}(_react.Component)) || _class);
exports.default = HeaderMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/HeaderMenu/HeaderMenu.js
// module id = 1359
// module chunks = 0